import type { TranslateKeys } from './types'

export function defineTranslateKeys<T extends TranslateKeys>(keys: T): T {
  return keys
}
